import { createContext, useContext } from 'react';
import { tWorkspaceContext } from './Workspace.types';
import { WORKSPACE_INITIAL_STATE } from './Workspace.constants';

export const WorkspaceContext = createContext<tWorkspaceContext>(
  WORKSPACE_INITIAL_STATE,
);

export function useWorkspaceContext(): tWorkspaceContext {
  return useContext(WorkspaceContext);
}
